import { useDeck } from '@/app/context/DeckContext/useDeck';
import * as React from 'react';
import { CSVLink } from 'react-csv';

const DownloadButton = ({ iconOnly, isLanding, onClick }) => {
  const { selectedDeck, selectedDeckData } = useDeck();

  let body = <></>;

  if (isLanding) {
    body = (
      <div className="card min-h-44 max-w-md cursor-pointer border-b-4 border-solid border-transparent bg-base-300 text-primary-content shadow-lg lg:card-side hover:border-secondary">
        <div className="card-body flex">
          <p className="break-all text-center text-lg font-bold text-base-content">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="-mt-1 mr-3 inline-block w-5 fill-base-content text-base-content"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M3 19h18v2H3v-2zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2v11.172z" />
              </svg>
            </span>
            Download {selectedDeckData?.cards.length} Flashcards
          </p>
          <p className="text-md mt-4 text-center text-base-content">
            Import into <span className="font-bold">Quizlet</span>,{' '}
            <span className="font-bold">Anki</span>,{' '}
            <span className="font-bold">Cram</span>,{' '}
            <span className="font-bold">Tinycards</span> or your preferred
            flashcard tool
          </p>
        </div>
      </div>
    );
  } else if (iconOnly) {
    body = (
      <div
        data-tip={`Download ${selectedDeckData?.cards?.length} Flashcards`}
        className="tooltip tooltip-bottom"
      >
        <div className="btn btn-ghost" onClick={onClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="inline-block w-6 fill-base-content text-base-content"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M3 19h18v2H3v-2zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2v11.172z" />
          </svg>
        </div>
      </div>
    );
  } else {
    body = (
      <div className="flex w-full max-w-md justify-center">
        <button
          onClick={onClick}
          className="flex w-full transform justify-center rounded bg-primary p-2 align-middle transition duration-300 ease-in-out hover:scale-105 hover:underline"
        >
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="mr-3 inline-block w-5 fill-base-content text-base-content"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M3 19h18v2H3v-2zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2v11.172z" />
            </svg>
          </span>
          <p>Download {selectedDeckData?.cards?.length} Flashcards</p>
        </button>
      </div>
    );
  }

  return (
    <CSVLink
      className="flex w-full max-w-md justify-center"
      target="_blank"
      onClick={() => {
        onClick();
      }}
      filename={'limbiks_' + selectedDeck?.name + '.csv'}
      data={selectedDeckData?.cards?.map((t) => [t.question, t.answer]) || []}
    >
      {body}
    </CSVLink>
  );
};

export default DownloadButton;
